export default __webpack_public_path__ + "static/media/Diabetes-Mellitus-1.416e03c8.jpg";